import { runAction } from "../checkout/actions/action-functions.js";
import { fetchSetTerms } from "./api/api.js";
import { getQuote } from "./custom_extras/xcover/xcover.js";
import { getBookingState, setBookingStateProp } from "./state.js";
import { prepareExtrasUI } from "./ui/extras.js";
import { toggle } from "./utils/ui-helpers.js";

/**
 * Used to run logic that should occur before the stage transition animation
 * @param {*} stageId a string identifying a stage  
 */
export async function onBeforeNextStageComplete(stageId) {
    const loadSpinner = document.getElementById('atb-loading-overlay-spinner');
    toggle(loadSpinner, true);

    const bookingState = getBookingState();

    switch(stageId) {
        case 'xcover': {            
            
            const response  = await getQuote();
            setBookingStateProp("can_refund_booking", response.canProtectBooking);

            const hasChosenXcover = getBookingState().use_booking_protect == 1;
            if (hasChosenXcover) {
                const requestObj = {
                    addon_id: '', // custom extras have no ID because they don't exist in the database
                    addon_value: 0,
                    custom_type: 'xcover',
                    custom: 1
                };

                requestObj['addon_value'] = 1;
                
                await getQuote();
        
                // Run all XCover actions
                const setResponse = await runAction('xcover', 'fetch', {value: '', data: requestObj});
                runAction('xcover', 'set',    { value: requestObj, data: setResponse });
                runAction('xcover', 'render', { value: requestObj, data: setResponse });  
            }

            break;
        }
        case 'extras': {
            await prepareExtrasUI(bookingState);
            break;
        }
        case 'party': {
            await fetchSetTerms();
            break;
        }
    }
    toggle(loadSpinner, false);
}